import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrmHttpClientService } from '../PrmHttpClientService';
import { PharmacyDto, PharmacyImportDto } from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})

export class PharmacyRepository {
  constructor(private httpClientService: PrmHttpClientService) {}

  private readonly pharmacyRoutePrefix = 'pharmacy/id';

  public getPharmacyById(id: string): Observable<PharmacyDto | null> {
    const endpointUrl = `lists/pharmacies/${id}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  public searchPharmacies(searchText: string): Observable<PharmacyDto[]> {
    const httpParams = new HttpParams().set('query', searchText);
    const endpointUrl = `lists/pharmacies`;
    return this.httpClientService.sendGetRequest(endpointUrl, httpParams);
  }

  public updatePharmacyItems(id: string, uId: string, pharmacyImports: PharmacyImportDto): Observable<number> {
    const endpointUrl = `${this.pharmacyRoutePrefix}/${id}/import/${uId}`;
    return this.httpClientService.sendPutRequest(endpointUrl, pharmacyImports);
  }
}
